export default {
  title_attachment: "Request Attachment Removal",
  title_image: "Request Image Removal",
  label: "Reasoning",
  content: "Please provide a reason for this request",
}
